module.exports = __webpack_public_path__ + "img/marengo-school-logo.1181c56f.jpg";